// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__dBMev","label":"LabeledBox_label__3RIj4"};